import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CashRegisterTerminalConfigPage } from './config/cashregister-terminal-config.page';

const cashRegisterRoutes: Routes = [
  {
    path:      '',
    component: CashRegisterTerminalConfigPage,
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(cashRegisterRoutes)
  ],
  exports: [RouterModule]
})
export class CashRegisterTerminalRoutingModule { }